// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Book Detail Modal Styles */

.book-detail-modal {
  max-width: 1400px !important;
  width: 90% !important;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.book-detail-body {
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  padding: 24px;
}

/* Book Info Section */
.book-info-section {
  display: flex;
  gap: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--border-color);
}

.book-cover-large {
  flex-shrink: 0;
  width: 200px;
  height: 300px;
  border-radius: 8px;
  overflow: hidden;
  background: var(--bg-secondary);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.book-cover-large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.book-cover-placeholder-large {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: white;
  padding: 1.5rem;
  text-align: center;
}

.book-cover-placeholder-large .material-symbols-outlined {
  font-size: 64px;
}

/* Large placeholder content with book title and author */
.book-cover-placeholder-large .placeholder-large-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  width: 100%;
}

.book-cover-placeholder-large .placeholder-large-title {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.3;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.book-cover-placeholder-large .placeholder-large-author {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.book-info-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.book-detail-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.book-detail-id {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0 0 16px 0;
}

.book-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 500;
}

.description-item {
  margin-top: 8px;
}

.info-description {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: 8px;
  border-left: 3px solid var(--primary-color);
}

/* History Section */
.history-section {
  flex: 1 1;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 16px 0;
}

.section-title .material-symbols-outlined {
  color: var(--primary-color);
}

/* Roadmap Container */
.roadmap-container {
  max-height: 500px;
  overflow-y: auto;
  padding: 8px;
}

.roadmap-container::-webkit-scrollbar {
  width: 8px;
}

.roadmap-container::-webkit-scrollbar-track {
  background: var(--bg-secondary);
  border-radius: 4px;
}

.roadmap-container::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

.roadmap-container::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}

/* Roadmap */
.roadmap {
  position: relative;
  padding-left: 24px;
}

.roadmap-item {
  position: relative;
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.roadmap-item:last-child {
  margin-bottom: 0;
}

.roadmap-marker {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.marker-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;
}

.marker-dot.status-borrowed {
  background: #dc2626;
}

.marker-dot.status-returned {
  background: #16a34a;
}

.marker-dot.status-lost {
  background: var(--error-color);
}

.marker-dot.status-added {
  background: #16a34a;
}

/* System Entry Styles */
.system-entry .record-card {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.05) 0%, rgba(34, 197, 94, 0.02) 100%);
  border-left: 3px solid var(--success-color);
}

.system-entry .record-borrower {
  color: var(--success-color);
}

.system-entry .record-borrower .material-symbols-outlined {
  color: var(--success-color);
}

.marker-line {
  width: 2px;
  flex: 1 1;
  background: var(--border-color);
  margin-top: 8px;
  min-height: 24px;
}

.roadmap-item:last-child .marker-line {
  display: none;
}

.roadmap-content {
  flex: 1 1;
  min-width: 0;
}

.record-card {
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--border-color);
  transition: box-shadow 0.2s ease;
}

.record-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.record-borrower {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: var(--text-primary);
}

.record-borrower .material-symbols-outlined {
  color: var(--primary-color);
  font-size: 20px;
}

.borrower-name {
  font-size: 15px;
}

.record-dates {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
}

.date-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text-secondary);
}

.date-item .material-symbols-outlined {
  font-size: 18px;
  color: var(--primary-color);
}

.date-label {
  font-weight: 500;
}

.date-value {
  font-weight: 600;
  color: var(--text-primary);
}

.record-contact {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--text-secondary);
  padding: 8px 12px;
  background: var(--bg-secondary);
  border-radius: 6px;
  margin-bottom: 8px;
}

.record-contact .material-symbols-outlined {
  font-size: 18px;
  color: var(--primary-color);
}

.record-notes {
  display: flex;
  gap: 8px;
  font-size: 13px;
  color: var(--text-secondary);
  padding: 8px 12px;
  background: var(--bg-secondary);
  border-radius: 6px;
  margin-bottom: 8px;
}

.record-notes .material-symbols-outlined {
  font-size: 18px;
  color: var(--primary-color);
  flex-shrink: 0;
}

.record-notes p {
  margin: 0;
  line-height: 1.5;
}

.record-late-fees {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--error-color);
  padding: 8px 12px;
  background: rgba(234, 67, 53, 0.1);
  border-radius: 6px;
  font-weight: 600;
}

.record-late-fees .material-symbols-outlined {
  font-size: 18px;
}

/* Empty State */
.empty-history {
  text-align: center;
  padding: 48px 24px;
  color: var(--text-secondary);
}

.empty-history .material-symbols-outlined {
  font-size: 64px;
  color: var(--border-color);
  margin-bottom: 16px;
}

.empty-history p {
  margin: 8px 0;
  font-size: 16px;
}

.empty-subtitle {
  font-size: 14px;
  color: var(--text-tertiary);
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: var(--text-secondary);
}

.loading-spinner {
  font-size: 48px;
  animation: spin 1s linear infinite;
  color: var(--primary-color);
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 1024px) {
  .book-detail-modal {
    max-width: 900px;
    width: calc(100% - 40px);
  }

  .book-info-section {
    flex-direction: column;
  }

  .book-cover-large {
    width: 160px;
    height: 240px;
    margin: 0 auto;
  }

  .book-info-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .book-info-section {
    flex-direction: column;
  }

  .book-cover-large {
    width: 120px;
    height: 180px;
    margin: 0 auto;
  }

  .book-info-grid {
    grid-template-columns: 1fr;
  }

  .roadmap-container {
    max-height: 300px;
  }
}

/* History Pagination */
.history-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  margin-top: 1rem;
  background-color: var(--slate-50);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
}

.history-pagination .btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-sub);
  border-radius: var(--radius-md);
  transition: all var(--transition-fast);
}

.history-pagination .btn-ghost:hover:not(:disabled) {
  background-color: var(--slate-100);
  color: var(--text-main);
}

.history-pagination .btn-ghost:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.history-pagination .pagination-info {
  font-size: 0.875rem;
  color: var(--text-sub);
  font-weight: 500;
}

@media (max-width: 768px) {
  .history-pagination {
    flex-direction: column;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/BookDetailModal.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sFAAsF;EACtF,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,6FAA6F;EAC7F,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,SAAO;EACP,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;AACF","sourcesContent":["/* Book Detail Modal Styles */\n\n.book-detail-modal {\n  max-width: 1400px !important;\n  width: 90% !important;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.book-detail-body {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n/* Book Info Section */\n.book-info-section {\n  display: flex;\n  gap: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.book-cover-large {\n  flex-shrink: 0;\n  width: 200px;\n  height: 300px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--bg-secondary);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.book-cover-large img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.book-cover-placeholder-large {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: white;\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.book-cover-placeholder-large .material-symbols-outlined {\n  font-size: 64px;\n}\n\n/* Large placeholder content with book title and author */\n.book-cover-placeholder-large .placeholder-large-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.book-cover-placeholder-large .placeholder-large-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1.3;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.book-cover-placeholder-large .placeholder-large-author {\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.4;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.book-info-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.book-detail-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 4px 0;\n  line-height: 1.3;\n}\n\n.book-detail-id {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin: 0 0 16px 0;\n}\n\n.book-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.info-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-value {\n  font-size: 14px;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.description-item {\n  margin-top: 8px;\n}\n\n.info-description {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin: 0;\n  padding: 12px;\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  border-left: 3px solid var(--primary-color);\n}\n\n/* History Section */\n.history-section {\n  flex: 1;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 16px 0;\n}\n\n.section-title .material-symbols-outlined {\n  color: var(--primary-color);\n}\n\n/* Roadmap Container */\n.roadmap-container {\n  max-height: 500px;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.roadmap-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.roadmap-container::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n  border-radius: 4px;\n}\n\n.roadmap-container::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 4px;\n}\n\n.roadmap-container::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary);\n}\n\n/* Roadmap */\n.roadmap {\n  position: relative;\n  padding-left: 24px;\n}\n\n.roadmap-item {\n  position: relative;\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.roadmap-item:last-child {\n  margin-bottom: 0;\n}\n\n.roadmap-marker {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.marker-dot {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 3px solid white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1;\n}\n\n.marker-dot.status-borrowed {\n  background: #dc2626;\n}\n\n.marker-dot.status-returned {\n  background: #16a34a;\n}\n\n.marker-dot.status-lost {\n  background: var(--error-color);\n}\n\n.marker-dot.status-added {\n  background: #16a34a;\n}\n\n/* System Entry Styles */\n.system-entry .record-card {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.05) 0%, rgba(34, 197, 94, 0.02) 100%);\n  border-left: 3px solid var(--success-color);\n}\n\n.system-entry .record-borrower {\n  color: var(--success-color);\n}\n\n.system-entry .record-borrower .material-symbols-outlined {\n  color: var(--success-color);\n}\n\n.marker-line {\n  width: 2px;\n  flex: 1;\n  background: var(--border-color);\n  margin-top: 8px;\n  min-height: 24px;\n}\n\n.roadmap-item:last-child .marker-line {\n  display: none;\n}\n\n.roadmap-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.record-card {\n  background: white;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  border: 1px solid var(--border-color);\n  transition: box-shadow 0.2s ease;\n}\n\n.record-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.record-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.record-borrower {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.record-borrower .material-symbols-outlined {\n  color: var(--primary-color);\n  font-size: 20px;\n}\n\n.borrower-name {\n  font-size: 15px;\n}\n\n.record-dates {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.date-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.date-item .material-symbols-outlined {\n  font-size: 18px;\n  color: var(--primary-color);\n}\n\n.date-label {\n  font-weight: 500;\n}\n\n.date-value {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.record-contact {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  padding: 8px 12px;\n  background: var(--bg-secondary);\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.record-contact .material-symbols-outlined {\n  font-size: 18px;\n  color: var(--primary-color);\n}\n\n.record-notes {\n  display: flex;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  padding: 8px 12px;\n  background: var(--bg-secondary);\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.record-notes .material-symbols-outlined {\n  font-size: 18px;\n  color: var(--primary-color);\n  flex-shrink: 0;\n}\n\n.record-notes p {\n  margin: 0;\n  line-height: 1.5;\n}\n\n.record-late-fees {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--error-color);\n  padding: 8px 12px;\n  background: rgba(234, 67, 53, 0.1);\n  border-radius: 6px;\n  font-weight: 600;\n}\n\n.record-late-fees .material-symbols-outlined {\n  font-size: 18px;\n}\n\n/* Empty State */\n.empty-history {\n  text-align: center;\n  padding: 48px 24px;\n  color: var(--text-secondary);\n}\n\n.empty-history .material-symbols-outlined {\n  font-size: 64px;\n  color: var(--border-color);\n  margin-bottom: 16px;\n}\n\n.empty-history p {\n  margin: 8px 0;\n  font-size: 16px;\n}\n\n.empty-subtitle {\n  font-size: 14px;\n  color: var(--text-tertiary);\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  color: var(--text-secondary);\n}\n\n.loading-spinner {\n  font-size: 48px;\n  animation: spin 1s linear infinite;\n  color: var(--primary-color);\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .book-detail-modal {\n    max-width: 900px;\n    width: calc(100% - 40px);\n  }\n\n  .book-info-section {\n    flex-direction: column;\n  }\n\n  .book-cover-large {\n    width: 160px;\n    height: 240px;\n    margin: 0 auto;\n  }\n\n  .book-info-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .book-info-section {\n    flex-direction: column;\n  }\n\n  .book-cover-large {\n    width: 120px;\n    height: 180px;\n    margin: 0 auto;\n  }\n\n  .book-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .roadmap-container {\n    max-height: 300px;\n  }\n}\n\n/* History Pagination */\n.history-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  margin-top: 1rem;\n  background-color: var(--slate-50);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n}\n\n.history-pagination .btn-ghost {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-sub);\n  border-radius: var(--radius-md);\n  transition: all var(--transition-fast);\n}\n\n.history-pagination .btn-ghost:hover:not(:disabled) {\n  background-color: var(--slate-100);\n  color: var(--text-main);\n}\n\n.history-pagination .btn-ghost:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.history-pagination .pagination-info {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .history-pagination {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
